"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/user/index.ts
var user_exports = {};
__export(user_exports, {
  OnboardingState: () => OnboardingState,
  SubscriptionPlan: () => SubscriptionPlan,
  UserAttribute: () => UserAttribute
});
module.exports = __toCommonJS(user_exports);

// src/user/User.ts
var UserAttribute = /* @__PURE__ */ ((UserAttribute2) => {
  UserAttribute2["ONBOARDED_FEATURES"] = "SEEN_FEATURE_HIGHLIGHTS";
  UserAttribute2["LAST_USED_AI_IMAGE_GEN_MODEL"] = "LAST_IMAGE_GEN_MODEL_USED";
  UserAttribute2["LAST_USED_AI_ADVANCED_IMAGE_GEN_MODEL"] = "LAST_ADVANCED_IMAGE_GEN_MODEL_USED";
  return UserAttribute2;
})(UserAttribute || {});
var SubscriptionPlan = /* @__PURE__ */ ((SubscriptionPlan2) => {
  SubscriptionPlan2["PRO"] = "PRO";
  SubscriptionPlan2["EXPERT"] = "EXPERT";
  return SubscriptionPlan2;
})(SubscriptionPlan || {});
var OnboardingState = /* @__PURE__ */ ((OnboardingState2) => {
  OnboardingState2["SignUp"] = "SIGN_UP";
  OnboardingState2["WhatDescribesYou"] = "WHAT_DESCRIBES_YOU";
  OnboardingState2["HearAboutUs"] = "HEAR_ABOUT_US";
  OnboardingState2["HowExperienced"] = "HOW_EXPERIENCED";
  OnboardingState2["CreateFirst"] = "CREATE_FIRST";
  OnboardingState2["UpgradePlan"] = "UPGRADE_PLAN";
  OnboardingState2["Survey"] = "SURVEY";
  OnboardingState2["ChooseTemplate"] = "CHOOSE_TEMPLATE";
  OnboardingState2["EditText"] = "EDIT_TEXT";
  OnboardingState2["TransformText"] = "TRANSFORM_TEXT";
  OnboardingState2["AddElement"] = "ADD_ELEMENT";
  OnboardingState2["ColorPalette"] = "COLOR_PALETTE";
  OnboardingState2["Download"] = "DOWNLOAD";
  OnboardingState2["Complete"] = "COMPLETE";
  OnboardingState2["Skipped"] = "SKIPPED";
  return OnboardingState2;
})(OnboardingState || {});
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  OnboardingState,
  SubscriptionPlan,
  UserAttribute
});
